import clsx from "clsx";
import type { ReactNode } from "react";

export type Tone = "neutral" | "green" | "gold" | "red" | "blue";

/** Each tone's text colour and its dot. */
const tones: Record<Tone, [string, string]> = {
  neutral: ["text-ink-2", "bg-ink-3"],
  green: ["text-ledger-dark", "bg-ledger"],
  gold: ["text-[#7a5a1c]", "bg-saffron"],
  red: ["text-danger", "bg-danger"],
  blue: ["text-info", "bg-info"],
};

/** A status: a coloured dot and its word, quiet enough for a column of them. */
export function Badge({ tone = "neutral", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span className={clsx("inline-flex items-center gap-1.5 text-[13px] font-medium whitespace-nowrap", tones[tone][0])}>
      <span className={clsx("size-[7px] shrink-0 rounded-full", tones[tone][1])} aria-hidden />
      {children}
    </span>
  );
}

/** Tone for a status value, shared by every list so colors mean the same thing everywhere. */
export function statusTone(s: string | undefined | null): Tone {
  switch (s) {
    case "issued": case "paid": case "won": case "accepted": case "active": case "approved": case "confirmed":
    case "converted": case "completed": case "invoiced":
      return "green";
    case "partial": case "sent": case "submitted": case "einvoice_pending": case "qualified": case "on_hold":
    case "invited": case "contacted":
      return "gold";
    case "cancelled": case "lost": case "declined": case "rejected": case "einvoice_rejected": case "void":
    case "disqualified": case "overpaid": case "inactive": case "expired":
      return "red";
    case "draft": case "new": case "open":
      return "blue";
    default:
      return "neutral";
  }
}
